import { render, staticRenderFns } from "./CompletedSettlement.vue?vue&type=template&id=58bb5950"
import script from "./CompletedSettlement.vue?vue&type=script&lang=js"
export * from "./CompletedSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports